import manifest from '../vscode-default-extensions/theme-seti/package.json.js';
import { registerExtension } from '../extensions.js';
import resource_0 from '../vscode-default-extensions/theme-seti/icons/seti.woff.extensionResource.js';
import { onExtHostInitialized } from '../vscode-services/extHost.js';
onExtHostInitialized(() => {
  const { registerFile, registerSyncFile, runCode } = registerExtension(manifest);
  registerFile('./icons/vs-seti-icon-theme.json', async () => await import('../vscode-default-extensions/theme-seti/icons/vs-seti-icon-theme.json.extensionResource.js').then(module => module.default ?? module));
  registerSyncFile('icons/seti.woff', resource_0, 'font/woff');
    runCode();
});
